/**
 * Alphabetical compare on `name` for the sidebar and sandbox lists.
 * Case-insensitive, and numeric-aware so "Car 2" sorts before "Car 10".
 */
export function byName<T extends { name: string }>(a: T, b: T): number {
  return a.name.localeCompare(b.name, 'en-GB', { sensitivity: 'base', numeric: true })
}

/** Sorts a copy, leaving the stored order alone. */
export function sortedByName<T extends { name: string }>(items: T[]): T[] {
  return [...items].sort(byName)
}
